import FooterContainer from "./containers/FooterContainer";
import "./styles.scss";

export default FooterContainer;
